import React from 'react'
import "./foreword.css"

const Foreword = () => {
  return (
    <div className="vorwort">
    <h2 className="vorwort-title">Vorwort</h2>
    <p>
      Der DevOps-Comicbookverlag ist ein kleines Unternehmen in einer
      magischen Steampunk-Welt. In dieser Welt gibt es keine Computer. Es
      geht hauptsächlich um die Analogie und um das Erklären von
      It-Begriffen mit anderer Elektronik. Die Menschen nutzen als soziale
      Medien daher magische Kristallkugeln und ähnliches.... DevOpsComics
      gibt mehrere Comic-Hefte und Bücher heraus, die sogenannten
      **Apps**. Die Hefte erscheinen wöchentlich oder monatlich. Die
      Bücher hingegen erst dann, wenn genügend Vorbestellungen **Tickets**
      eingegangen sind. Die Comics werden im eigenen Souvenir-Shop auf dem
      Firmengelände verkauft, aber auch auf den Marktplätzen in den
      Städten und Dörfern. Viele Fans haben aber auch ein Abo
      abgeschlossen und bekommen die neusten Ausgaben direkt ins Haus
      geliefert. DevOps beschäftigt eine ganze Reihe Mitarbeiter in
      verschiedenen Abteilungen, Künstler wie Autoren und Grafiker,
      Handwerker wie den Hausmeister und die Drucker,
      Verwaltungsfachangestellte und Büroboten und viele mehr...
      <br />
      <br />
      Die Fans der Comics sind teilweise richtige Besserwisser und daher
      wird großer Wert daraufgelegt, immer pünktlich zu liefern und die
      Rechtmäßigkeit der einzelnen Geschichten nicht zu verletzten.
      <br />
      <br />
      Aus diesem Grund beobachten die Mitarbeiter aus der Abteilung
      Market-Research, die **Monitoren** und **Observer** genau was in der
      Öffentlichkeit, über die neuesten Ausgaben und Entwicklungen der
      Bücher gesagt wird. Es werden die Kritiken in der Tageszeitung und
      der Fanpost durchgelesen, zusammengefasst und weitergereicht. Auch
      wird tief in die Kristallkugel geschaut, um die Diskussionen der
      Fans in den sozialen Medien zu beobachten. Die **Monitoren** selbst
      beteiligen sich aber nicht daran. z.B. gab es in der Vergangenheit
      gehäuft Anmerkung darüber, dass die Farben neuerdings blasser
      aussehen und nachdem die **Monitoren** diese Meinung weitergereicht
      hatten, wurde (viel) später festgestellt, dass die Farben zwar in
      Ordnung aber die Qualität des Papieres nachgelassen hatte...
      <br />
      <br />
      Jeden Morgen lesen die Show-Runner oder auch **Planer** die Berichte
      der **Monitoren** und die Briefe der Kunden bei einer Tasse extra
      starken, heißen Kaffee. Außer Gwendoline die trinkt lieber Kakao.
      Jeder Show-Runner ist für eine oder mehrere Heftreihen
      verantwortlich. Gwendoline betreut die langjährige Erfolgsreihen
      "Phillip liebt Nancy" und "Mein Hut hat vier Ecken". Bei schwierigen
      Entscheidungen trifft sie sich öfters sogar mit dem Vorsitzenden des
      "Phillip liebt Nancy-Fan-Klubs" um mit ihren Entscheidungen die
      treuen Anhänger nicht zu enttäuschen, sondern eher bestenfalls zu
      erfreuen. Viele Fans sehnen das erste Rendezvous zwischen Phillip
      und Nancy herbei und andere würden gerne sehen, dass der Streit mit
      Phillips Rivalen eskaliert. Gwendoline baut auch gerne kleine
      Eastereggs ein. So tauchen gerne einmal Geschäfte, die besonders
      viel Exemplare verkauft haben im Hintergrund einer Grafik auf oder
      der Geburtstag des allerersten Abonnenten wird gefeiert. Die Planer
      geben grobe Ziele vor, wie sich die einzelnen Geschichten in der
      Zukunft weiterentwickeln. Welche Charaktere eher unbeliebt sind oder
      als eher langweilig empfunden werden und langfristig aus der
      Geschichte rausgeschrieben werden sollen. Der "verrückte
      Wissenschaftler" aus "mein Hut hat vier Ecken" ist so beliebt, dass
      die Show-Runner eine eigene Spin-off-Serie rund um diesen
      schrulligen Typen vorbereiten...
      <br />
      <br />
      Die Autoren, im Verlag auch gerne die **Coder** genannt, bekommen
      zum Wochenstart eine eher wage Zielsetzung für die nächsten
      Ausgaben. So soll "Nancy" Probleme an ihrem Arbeitsplatz haben, die
      sie irgendwie stresst, die Episode soll lustig sein aber keine
      tiefgreifenden Impakt auf die langfristige Entwicklung der
      Geschichte haben. Die **Coder** prüfen nun, wie diese Anforderung
      konkret umgesetzt werden kann. Wer in der Drogerie in welcher Nancy
      arbeitet, ist lustig? Da kommen mehrere in Frage: Der Mob-boy, die
      Chefin oder der Kontrolleur vom Gesundheitsamt? Alle diese
      Charaktere sind den Kunden ausreichend bekannt und auch lustig,
      besonders Mob-boy... aber Mob-Boy wird noch für einen langfristige
      Story-Arc gebraucht, wenn sich herausstellt, dass er Phillips lange
      vermisster Halbbruder ist und darf für eine kurze Episode nicht
      verheizt werden. Daher wird eine kleine Geschichte geschrieben, in
      der die Chefin immer wieder Nancys Erdebeermarmeladenbrot mit Honig
      stibitzt und Nancy anfängt an ihrem Verstand zu zweifeln. Das
      Storyboard der **Coder** ist jetzt schon sehr konkret, in wie vielen
      Bildern wird das Brot gezeigt und wie breit ist das verschmitzte
      Lächeln der Chefin...
      <br />
      <br />
      Die Künstler von **Build** erhalten das relativ, uninspirierende
      Storyboard von den Kollegen aus **Code**. Soll die nächste Aufgabe
      auf der 7 Farben Siebdruckmaschine gedruckt werden die mit roter,
      grüner und blauer Farbe arbeitet oder auf der Neuen mit Cyan,
      Magenta und Gelb? Wieder keine Angaben zum Cover oder ob es ein
      Vorwort geben soll.... Aber, ist ja nichts neues die **Builder**
      wissen ja wie sie ihren Job zu machen haben. Es wird ein großartiges
      Titelbild entworfen, wie Nancys Chefin lustvoll in ein Brot beißt...
      <br />
      <br />
      Die Editoren von **Test** sind entsetzt. Wie kann **Build** das
      Geheimnis wer der Pausenbrotdieb ist, schon auf der Titelseite
      verraten! Die **Coder** haben völlig übersehen, dass die Chefin seit
      Band 12/18 vor drei Jahren eine Allergie gegen Honig hat und die
      **Planer** haben vergessen, dass Phillip in dieser Woche das
      Hochzeitsgeschenk für seine Schwester vorbereiten muss, damit er es
      ihr am Monatsende beim großen Staffelfinale überreichen kann....
      Außerdem wird dieses Mal, "Der Hut mit den Vier Ecken" auf der neuen
      Druckerpresse gedruckt, da es ein Poster vom "verrückten
      Wissenschaftler" als Beilage hat... Die Farben müssen daher in RGB
      sein.... So kann das Heft auf keinen Fall erscheinen.... Ok …. diese
      Woche war eine gute Woche... nur drei, vier Runden und alles scheint
      auf dem ersten Blick zu passen. Über Kleinigkeiten wie den
      verschwundenen Kaffeefleck auf dem Sofa in der Drogerie wird diesmal
      großzügig hinweggesehen.
      <br />
      <br />
      Die Drucker von **Release und Config** sind verzweifelt. Zugegeben
      die Cover sehen auch diese Woche wieder einfach fantastisch aus aber
      wo sollen die Etiketten mit den Adressen der Abonnenten aufgeklebt
      werden, ohne diese zu verschandeln. Die Gewerkschaft der Brieftauben
      weigert sich doch seid neuesten Bücher mit Vollverpackung zu
      transportieren, aus Umweltschutz und Gewichtsgründen. Die Buchläden
      bestehen aber darauf, dass die Heftreihe, Bandnummer und Staffel
      eindeutig auf dem Buchrücken zu lesen sind, um diese vernünftig in
      die Bücherregale sortieren zu können. Da muss auch eine Lösung her,
      und die soll dauerhaft sein ein Aufkleber tut es da nicht.
    </p>
  </div>
  )
}

export default Foreword